import home from '@views/home/home';
import brandHome from '@views/home/brandHome';
import allSearch from '@views/home/allSearch';
import sunhomedetail from '@views/home/sunhomedetail';
import sunhomelist from '@views/home/sunhomelist';

const homeRouter = [{
	path: 'home',
	name: 'home',
	// component: home,
  	component: resolve => require(['@views/home/home'],resolve),
	meta:{
		title: '美心门商城',
		id: '1'
	}
},{
	path: 'brandHome',
	name: 'brandHome',
	// component: brandHome
  	component: resolve => require(['@views/home/brandHome'],resolve),
},{
	path: 'allSearch',
	name: 'allSearch',
	// component: allSearch
  	component: resolve => require(['@views/home/allSearch'],resolve),
},{
	path: 'sunhomedetail',
	name: 'sunhomedetail',
	// component: sunhomedetail
  	component: resolve => require(['@views/home/sunhomedetail'],resolve),
},{
	path: 'sunhomelist',
	name: 'sunhomelist',
	// component: sunhomelist,
  	component: resolve => require(['@views/home/sunhomelist'],resolve),
	meta:{
		keepAlive: true
	}
}]

export default homeRouter;


// WEBPACK FOOTER //
// ./src/router/home/index.js